export const CalOnlineAvatar = {
  position: 'relative',
  width: 'C',
  height: 'C',
  round: '50%',
  borderWidth: '2px',
  borderColor: 'overlayStrong',
  borderStyle: 'solid',
  flexShrink: '0',
  marginLeft: '-Z',
  background: (el, s) => el.call('colorFromEmail', s.email || ''),
  align: 'center center',
  cursor: 'pointer',
  title: (el, s) => s.name || s.email || '',
  onClick: (e, el, s) => {
    if (s.email) el.state.root.update({ profileEmail: s.email })
  },

  Initial: {
    tag: 'span',
    fontSize: 'Y2',
    fontWeight: '700',
    color: 'white',
    text: (el, s) => {
      const n = s.name || s.email || '?'
      const parts = n.split(/[\s@.]+/).filter(Boolean)
      return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase()
    }
  },

  OnlineDot: {
    position: 'absolute',
    bottom: '-1px',
    right: '-1px',
    width: 'Z',
    height: 'Z',
    round: '50%',
    background: 'green',
    borderWidth: '2px',
    borderColor: 'overlayStrong',
    borderStyle: 'solid'
  }
}

export const CalOnlineUsersBar = {
  flow: 'x',
  align: 'center right',
  paddingLeft: 'Z',

  childExtends: 'CalOnlineAvatar',
  childrenAs: 'state',
  children: (el, s) => {
    const max = el.maxAvatars || 6
    const online = s.root.onlineUsers || []
    const me = s.root.currentUserEmail
    const byEmail = el.call('peopleByEmail')
    const enriched = online
      .filter(u => u.email !== me)
      .map(u => ({ email: u.email, name: byEmail[u.email]?.name || u.email }))
      .slice(0, max)
    const overflow = (online.length - 1) - enriched.length
    if (overflow > 0) {
      enriched.push({ email: `+${overflow}`, name: `${overflow} more online`, _overflow: true })
    }
    return enriched
  }
}
